import styles from '../../styles/admin/SolverLayout.module.scss'

interface SignInLayoutProps {
  children: React.ReactNode
}

const SolverLayout = ({ children }: SignInLayoutProps) => {
  return (
    <div className={styles.container}>
      <img
        src="/assets/top-background.png"
        alt="Abstract Top"
        className={styles.abstractTop}
      />
      <img
        src="/assets/bottom-left-background.png"
        alt="Union"
        className={styles.union}
      />
      <img
        src="/assets/bottom-right-background.png"
        alt="Abstract Bottom"
        className={styles.abstractBottom}
      />
      <img
        src="/assets/bottom-right-background-mobile.png"
        alt="Abstract Bottom Mobile"
        className={styles.abstractBottomMobile}
      />
      {children}
    </div>
  )
}

export default SolverLayout
